import { InjectionToken, inject } from '@angular/core';
import { RequestFactFindDefaultService } from './request-fact-find.default.service';

export interface IRequestFactFindService {
  requestFrom: string[];
  requested$: import('rxjs').Subject<void>;

  requestFactFind(paramMap: import('@angular/router').ParamMap, journal: any): Promise<void>;
}

export const REQUEST_FACTFIND_SERVICE = new InjectionToken<IRequestFactFindService>('REQUEST_FACTFIND_SERVICE', {
  providedIn: 'root',
  factory: () => inject(RequestFactFindDefaultService)
});
